import React, { useState, useEffect } from 'react';
import {
    updateSchoolYear,
    getSchoolYear,
    uploadLogoSchool,
    fetchLogo,
    deleteLogoSchool,
    hasOpenDiary,
    generateStudentsHistory,
    generateStudentsHistoryConcept,
    updateAssessmentRegime,
    getAssessmentRegime,
} from '../../Api';
import {
    Container,
    PageHeader,
    PanelsGrid,
    ContainerYearControl,
    YearBox,
    ButtonNextYear,
    UploadContainer,
    Preview,
    FileInput,
    ButtonUpload,
    ButtonDelete,
    RegimeRow,
    RegimeSelect,
    RegimeButton,
    Notification,
    ModalOverlay,
    ModalContent,
    ModalButtons,
    ModalOverlayDelete,
    ModalBox,
    ModalButtonsDelete,
    TurmaList,
    TurmaItem,
    Button,
    FinalizingCard,
    SkeletonPanel,
} from './style';
import LoadingSpinner from '../../components/Loading';
import AuditPanel from '../../components/AuditPanel';

const Matter = () => {
    const [loading, setLoading] = useState(false);
    const currentYear = new Date().getFullYear();
    const [schoolYear, setSchoolYear] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModalPrevious, setShowModalPrevious] = useState(false);

    const [showWarning, setShowWarning] = useState(false);
    const [turmasPendentes, setTurmasPendentes] = useState([]);

    const [logoFile, setLogoFile] = useState(null);
    const [logoUrl, setLogoUrl] = useState('');
    const [logoId, setlogoId] = useState('');
    const [uploading, setUploading] = useState(false);

    const [showConfirm, setShowConfirm] = useState(false);

    const [previewUrl, setPreviewUrl] = useState('');

    const [finalizingYear, setFinalizingYear] = useState(false);
    const [finalizingMessage, setFinalizingMessage] = useState("");

    const [positionAtEducationDepartment, setPositionAtEducationDepartment] = useState('')

    const [notification, setNotification] = useState("");

    const [assessmentFormat, setassessmentFormat] = useState('');
    const [assessmentRegime, setAssessmentRegime] = useState('');
    const [showAssessmentRegimeModal, setShowAssessmentRegimeModal] = useState(false);

    const [position_at_school, setPosition_at_school] = useState('');
    const [blocked, setBlocked] = useState(false);

    useEffect(() => {
        let cancelled = false;

        (async () => {
            setLoading(true);
            const idSchool = JSON.parse(sessionStorage.getItem('id-school'));

            // ── fetches independentes em paralelo (antes eram em série) ──
            const [res, response] = await Promise.all([
                getSchoolYear(idSchool),
                getAssessmentRegime(idSchool),
            ]);

            if (cancelled) return;

            setSchoolYear(res.data.data);

            const schoolYearValue = res.data.data; // ano da escola
            const now = new Date();
            const yearNow = now.getFullYear();
            const currentMonth = now.getMonth(); // 0-11

            if (Number(schoolYearValue) === yearNow && currentMonth > 1) {
                setBlocked(true);
            }

            const position = localStorage.getItem('position_at_school');
            setPosition_at_school(position);

            const $assessmentFormat = sessionStorage.getItem('assessmentFormat')
            setassessmentFormat($assessmentFormat)

            if (response?.data?.data) {
                setAssessmentRegime(response.data.data)
            }

            const cachedLogo = localStorage.getItem(`school-logo-${idSchool}`);
            const cachedLogoId = localStorage.getItem(`school-logo-id-${idSchool}`);

            if (cachedLogo && cachedLogoId) {
                setLogoUrl(cachedLogo);
                setlogoId(cachedLogoId);
            } else {
                const logoRes = await fetchLogo(idSchool);
                if (cancelled) return;
                if (logoRes?.url) {
                    setLogoUrl(logoRes.url);
                    setlogoId(logoRes._id);
                    localStorage.setItem(`school-logo-${idSchool}`, logoRes.url);
                    localStorage.setItem(`school-logo-id-${idSchool}`, logoRes._id);
                }
            }

            const positionAtEducationDepartment = localStorage.getItem("positionAtEducationDepartment")
            setPositionAtEducationDepartment(positionAtEducationDepartment)
            setLoading(false);
        })();

        return () => { cancelled = true; };
    }, []);

    useEffect(() => {
        const message = sessionStorage.getItem("notification");
        if (message) {
            showNotification(message);
            sessionStorage.removeItem("notification"); // limpa após exibir
        }
    }, []);

    // libera o objectURL do preview ao trocar/desmontar (evita vazamento de memória)
    useEffect(() => {
        return () => {
            if (previewUrl) URL.revokeObjectURL(previewUrl);
        };
    }, [previewUrl]);

    const showNotification = (message) => {
        setNotification(message);
        setTimeout(() => setNotification(""), 4000); // desaparece depois de 4 segundos
    };

    const handleNextYearClick = () => {
        setShowModal(true);
    };

    const handlePreviousYearClick = () => {
        setShowModalPrevious(true);
    };

    const handleConfirmNextYear = async () => {

        setShowModal(false);
        setFinalizingYear(true);
        setFinalizingMessage("Verificando diários e preparando finalização do ano letivo...");
        const idSchool = JSON.parse(sessionStorage.getItem('id-school'));

        try {
            const response = await hasOpenDiary(idSchool, schoolYear);

            const { podeAvancar, turmasComDiarioAberto = [] } = response.data;

            // 🔹 Se regime for BIMESTRAL → mantém regra atual
            if (assessmentRegime?.toUpperCase() === "BIMESTRAL") {

                if (podeAvancar) {
                    await finalizarAno();
                } else {
                    setTurmasPendentes(turmasComDiarioAberto);
                    setShowWarning(true);
                    setFinalizingYear(false);
                    setFinalizingMessage("");
                }

            } else {

                // 🔹 Se for TRIMESTRAL → ignorar 4º bimestre
                const turmasComPendenciaTrimestral = turmasComDiarioAberto.filter((turma) => {

                    const periodosTrimestrais = ["1º BIMESTRE", "2º BIMESTRE", "3º BIMESTRE"];

                    return periodosTrimestrais.some((periodo) => {

                        const diario = turma.dailyStatus?.[periodo];

                        if (!diario) return true;

                        return Object.values(diario).some(
                            (status) => status !== "fechado"
                        );
                    });
                });

                if (turmasComPendenciaTrimestral.length === 0) {
                    await finalizarAno();
                } else {
                    setTurmasPendentes(turmasComPendenciaTrimestral);
                    setShowWarning(true);
                    setFinalizingYear(false);
                    setFinalizingMessage("");
                }
            }
        } catch (err) {
            console.error("Erro ao verificar diário:", err);
            setFinalizingYear(false);
            setFinalizingMessage("");
            alert("Ocorreu um erro ao tentar avançar o ano letivo.");
        }
    };

    const finalizarAno = async () => {

        const idSchool = JSON.parse(sessionStorage.getItem('id-school'));
        const nextYear = schoolYear + 1;

        setFinalizingMessage("Criando histórico anual dos alunos, aguarde...");

        if (assessmentFormat === "concept") {
            await generateStudentsHistoryConcept(idSchool, schoolYear);
        }

        if (assessmentFormat === "grade") {
            await generateStudentsHistory(idSchool, schoolYear);
        }

        setFinalizingMessage("Finalizando e atualizando ano letivo...");
        await updateSchoolYear(idSchool, nextYear);

        setFinalizingYear(false);
        sessionStorage.setItem("notification", `Ano letivo alterado para ${nextYear}`);
        window.location.reload();
    };

    const handleConfirmPreviousYear = async () => {
        setLoading(true);
        const idSchool = JSON.parse(sessionStorage.getItem('id-school'));
        const previousYear = Number(schoolYear) - 1;

        await updateSchoolYear(idSchool, previousYear);
        setLoading(false);
        setShowModalPrevious(false);
        sessionStorage.setItem("notification", `Ano letivo alterado para ${previousYear}`);
        window.location.reload();
    };

    const handleCancel = () => {
        setShowModal(false);
        setShowModalPrevious(false);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file && file.type === "image/png") {
            const img = new Image();
            const objectUrl = URL.createObjectURL(file);
            img.src = objectUrl;

            img.onload = () => {
                if (img.width > 500 || img.height > 500) {
                    alert("A imagem deve ter no máximo 500x500 pixels.");
                    setLogoFile(null);
                    setPreviewUrl('');
                    e.target.value = null;
                    URL.revokeObjectURL(objectUrl);
                    return;
                }

                setLogoFile(file);
                setPreviewUrl(objectUrl); // <- Adiciona preview temporário
            };
        } else {
            alert("Envie apenas arquivos PNG.");
            e.target.value = null;
            setLogoFile(null);
            setPreviewUrl('');
        }
    };

    const handleUploadLogo = async () => {
        if (logoUrl) {
            alert("Já existe uma logo enviada. Exclua ou substitua manualmente no sistema se necessário.");
            return;
        }

        if (!logoFile) {
            alert("Selecione uma imagem para enviar.");
            return;
        }

        setUploading(true);
        const formData = new FormData();
        formData.append("file", logoFile); // campo 'file' para bater com backend

        try {
            // Passa o id da escola na URL (req.params)
            const idSchool = JSON.parse(sessionStorage.getItem("id-school"));
            const res = await uploadLogoSchool(idSchool, formData);
            if (res) {
                alert("Logo enviada com sucesso!");
                window.location.reload()
            }
        } catch (err) {
            console.error("Erro ao enviar logo:", err);
            alert("Erro ao enviar a logo.");
        }
        setUploading(false);
    };

    const handleConfirmDelete = async () => {
        setShowConfirm(false);
        await handleDeleteLogo(); // chama a função real
    };

    const handleDeleteLogo = async () => {
        const idSchool = JSON.parse(sessionStorage.getItem("id-school"));

        try {
            await deleteLogoSchool(logoId, idSchool); // logoId = ID do logo salvo
            localStorage.removeItem(`school-logo-${idSchool}`);
            localStorage.removeItem(`school-logo-id-${idSchool}`);
            setLogoUrl(""); // Remove visualmente
            alert("Logo removida com sucesso!");
        } catch (err) {
            console.error("Erro ao remover logo:", err);
            alert("Erro ao remover a logo.");
        }
    };

    const handleSaveAssessmentRegime = async () => {
        if (!assessmentRegime) {
            alert('Selecione um regime de avaliação.');
            return;
        }

        const idSchool = JSON.parse(sessionStorage.getItem('id-school'));

        await updateAssessmentRegime(idSchool, assessmentRegime);

        sessionStorage.setItem('assessmentRegime', assessmentRegime);

        alert('Regime de avaliação salvo com sucesso!');
        window.location.reload()
    };

    const canManage = positionAtEducationDepartment || position_at_school === 'DIRETOR/SUPERVISOR';

    // ── SKELETON ──
    if (loading && !finalizingYear) {
        return (
            <Container>
                <SkeletonPanel $h="90px" />
                <SkeletonPanel $h="180px" />
                <SkeletonPanel $h="220px" />
            </Container>
        );
    }

    return (
        <Container>

            {finalizingYear && (
                <ModalOverlay>
                    <FinalizingCard>
                        <LoadingSpinner />
                        <p>{finalizingMessage}</p>
                    </FinalizingCard>
                </ModalOverlay>
            )}

            {notification && <Notification>{notification}</Notification>}

            <PageHeader>
                <h1>⚙️ Configurações</h1>
                <p>Configurações gerais da escola</p>
            </PageHeader>

            {/* ── Painéis lado a lado ── */}
            <PanelsGrid>
                {/* ── Ano Letivo ── */}
                <ContainerYearControl>
                    <h2>📅 Ano Letivo</h2>
                    <YearBox>
                        <p>Ano Letivo Atual</p>
                        <h1>{schoolYear}</h1>
                    </YearBox>
                    {(schoolYear !== currentYear && canManage) && (
                        <ButtonNextYear onClick={handleNextYearClick}>
                            Finalizar e Passar para o Próximo Ano Letivo →
                        </ButtonNextYear>
                    )}
                    {(schoolYear === currentYear && canManage) && (
                        <ButtonNextYear onClick={handlePreviousYearClick}>
                            ← Voltar para o Ano Letivo Anterior
                        </ButtonNextYear>
                    )}
                </ContainerYearControl>

                {/* ── Logo da escola ── */}
                <UploadContainer>
                    <h2>🏫 Logo da Escola</h2>
                    {(logoUrl || previewUrl) && (
                        <Preview src={previewUrl || logoUrl} alt="Logo da escola" />
                    )}

                    {!logoUrl && (
                        <>
                            <FileInput type="file" accept="image/png" onChange={handleFileChange} />
                            <ButtonUpload onClick={handleUploadLogo} disabled={uploading}>
                                {uploading ? "Enviando..." : "Enviar Logo"}
                            </ButtonUpload>
                        </>
                    )}
                    {logoUrl && (
                        <ButtonDelete onClick={() => setShowConfirm(true)}>
                            🗑️ Remover Logo
                        </ButtonDelete>
                    )}
                </UploadContainer>

                {/* ── Recuperação (escolas com nota) ── */}
                {canManage && sessionStorage.getItem('assessmentFormat') === 'grade' && (
                    <ContainerYearControl>
                        <h2>🔁 Recuperação</h2>
                        <p style={{ margin: '0 0 12px', fontSize: 14 }}>
                            Defina como a nota da recuperação entra no boletim (maior nota, média ou até a média).
                        </p>
                        <RegimeButton onClick={() => { window.location.href = '/recovery-config'; }}>
                            Configurar recuperação
                        </RegimeButton>
                    </ContainerYearControl>
                )}

                {/* ── Regime de avaliação ── */}
                {canManage && (
                    <ContainerYearControl>
                        <h2>📐 Regime de Avaliação</h2>
                        <RegimeRow>
                            <RegimeSelect
                                value={assessmentRegime}
                                onChange={(e) => setAssessmentRegime(e.target.value)}
                            >
                                <option value="">Selecione</option>
                                <option value="BIMESTRAL">Bimestral</option>
                                <option value="TRIMESTRAL">Trimestral</option>
                            </RegimeSelect>
                            <RegimeButton
                                disabled={!assessmentRegime}
                                onClick={() => setShowAssessmentRegimeModal(true)}
                            >
                                Alterar
                            </RegimeButton>
                        </RegimeRow>
                    </ContainerYearControl>
                )}
            </PanelsGrid>

            {/* ── Histórico de movimentações (full width, abaixo dos painéis) ── */}
            <AuditPanel canManage={canManage} />

            {/* ── Modais ── */}
            {showModal && (
                <ModalOverlay onClick={handleCancel}>
                    <ModalContent onClick={(e) => e.stopPropagation()}>
                        <h3>⚠️ Atenção!</h3>
                        <p>
                            Verifique se todos os dados do ano letivo atual foram finalizados corretamente.
                            <br /><br />
                            Ao alterar o ano letivo, todos os professores terão acesso apenas às turmas do novo ano letivo configurado,
                            e todas as informações exibidas no sistema serão referentes exclusivamente a este novo ano.
                            <br /><br />
                            Esta alteração impacta todos os usuários do sistema.
                        </p>
                        <ModalButtons>
                            <button onClick={handleConfirmNextYear}>Confirmar</button>
                            <button onClick={handleCancel}>Cancelar</button>
                        </ModalButtons>
                    </ModalContent>
                </ModalOverlay>
            )}

            {showModalPrevious && (
                <ModalOverlay onClick={handleCancel}>
                    <ModalContent onClick={(e) => e.stopPropagation()}>
                        <h3>⚠️ Atenção!</h3>
                        {blocked ? (
                            <p>
                                Ao retroceder o ano letivo, o Diário dos professores ficará indisponível
                                enquanto o ano configurado for diferente do ano atual.
                                <br /><br />
                                Oriente os professores a aguardarem a regularização para evitar
                                problemas com lançamentos e registros.
                                <br /><br />
                                O Diário voltará a ficar disponível assim que o ano letivo
                                estiver configurado corretamente.
                            </p>
                        ) : (
                            <p>
                                Antes de retroceder o ano letivo, verifique se isso é realmente necessário.
                                <br /><br />
                                Essa ação impacta todos os professores e usuários, que verão apenas as
                                turmas e informações do ano letivo configurado.
                            </p>
                        )}
                        <ModalButtons>
                            <button onClick={handleConfirmPreviousYear}>Confirmar</button>
                            <button onClick={handleCancel}>Cancelar</button>
                        </ModalButtons>
                    </ModalContent>
                </ModalOverlay>
            )}

            {showConfirm && (
                <ModalOverlayDelete onClick={() => setShowConfirm(false)}>
                    <ModalBox onClick={(e) => e.stopPropagation()}>
                        <p style={{ textAlign: 'center' }}>Tem certeza que deseja excluir a logo da escola?</p>
                        <ModalButtonsDelete>
                            <button onClick={handleConfirmDelete}>Sim</button>
                            <button onClick={() => setShowConfirm(false)}>Cancelar</button>
                        </ModalButtonsDelete>
                    </ModalBox>
                </ModalOverlayDelete>
            )}

            {showWarning && (
                <ModalOverlay onClick={() => setShowWarning(false)}>
                    <ModalContent onClick={(e) => e.stopPropagation()}>
                        <h2>⚠️ Não é possível avançar</h2>
                        <p>
                            Para finalizar o ano letivo e avançar para o próximo ano, é necessário
                            que todos os diários estejam fechados.
                        </p>
                        <p>As seguintes turmas ainda possuem diários abertos:</p>
                        <TurmaList>
                            {turmasPendentes.map((turma) => (
                                <TurmaItem key={turma._id}>
                                    {turma.name} - {turma.shift}
                                </TurmaItem>
                            ))}
                        </TurmaList>
                        <Button onClick={() => setShowWarning(false)}>Fechar</Button>
                    </ModalContent>
                </ModalOverlay>
            )}

            {showAssessmentRegimeModal && (
                <ModalOverlay onClick={() => setShowAssessmentRegimeModal(false)}>
                    <ModalContent onClick={(e) => e.stopPropagation()}>
                        <h3>⚠️ Atenção</h3>
                        <p>
                            A alteração do regime de avaliação poderá impactar diretamente os períodos avaliativos já configurados.
                        </p>
                        <p>
                            Caso o regime seja alterado de bimestral para trimestral e exista um 4º bimestre definido, este período será removido automaticamente, pois não é compatível com o regime trimestral.
                        </p>
                        <p>
                            Recomenda-se revisar os períodos de avaliação após a alteração para garantir a consistência das informações acadêmicas.
                        </p>
                        <div className="modal-buttons">
                            <button
                                className="modal-button confirm"
                                onClick={async () => {
                                    await handleSaveAssessmentRegime();
                                    setShowAssessmentRegimeModal(false);
                                }}
                            >
                                Confirmar
                            </button>
                            <button
                                className="modal-button cancel"
                                onClick={() => setShowAssessmentRegimeModal(false)}
                            >
                                Cancelar
                            </button>
                        </div>
                    </ModalContent>
                </ModalOverlay>
            )}

        </Container>
    );
};

export default Matter;